export const PACK_SIZES = [50, 100, 150, 200, 300, 600];
export const MIN_PILLS = 50;
export const MAX_PILLS = 600;

export const SHIPPING_TIERS = [
  { min: 50, max: 200, cost: 15, label: "50 – 200 pills" },
  { min: 201, max: 300, cost: 25, label: "201 – 300 pills" },
  { min: 301, max: 600, cost: 35, label: "301 – 600 pills" },
];

export function calcShipping(totalPills) {
  if (totalPills < MIN_PILLS || totalPills > MAX_PILLS) return 0;
  if (totalPills <= 200) return 15;
  if (totalPills <= 300) return 25;
  return 35;
}

export function fmtMoney(n) {
  const v = Number(n || 0);
  return `$${v.toFixed(2)}`;
}

export const ORDER_STATUSES = [
  "Pending", "Payment Pending", "Payment Received", "Processing",
  "Prescription Verification", "Confirmed", "Shipped", "Delivered",
  "Cancelled", "Refunded",
];

export const STATUS_COLORS = {
  "Pending": "bg-slate-100 text-slate-700",
  "Payment Pending": "bg-amber-50 text-amber-700",
  "Payment Received": "bg-emerald-50 text-emerald-700",
  "Processing": "bg-blue-50 text-blue-700",
  "Prescription Verification": "bg-indigo-50 text-indigo-700",
  "Confirmed": "bg-emerald-50 text-emerald-700",
  "Shipped": "bg-sky-50 text-sky-700",
  "Delivered": "bg-green-100 text-green-800",
  "Cancelled": "bg-red-50 text-red-700",
  "Refunded": "bg-rose-50 text-rose-700",
};
